import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';

import StorePresenter from '../../../../../../../../presenters/StorePresenter';
import appRoutes from '../../../../../../../../routes/appRoutes';

export const StoreCell = (props) => {
  const { store, isChecked, onStoreCheck } = props;
  const history = useHistory();

  const handleRedirectToStorePage = () => {
    const storeId = StorePresenter.id(store);
    const path = appRoutes.storeShowPath(storeId);
    history.push(path);
  };

  const handleStoreCheck = () => onStoreCheck(StorePresenter.id(store));

  const isArchived = StorePresenter.isArchived(store);

  return (
    <tr className={cn('', { '-removed': isArchived })}>
      <td className="checkbox-cell" onClick={handleStoreCheck}>
        <input
          type="checkbox"
          id={`isChecked-${StorePresenter.id(store)}`}
          checked={isChecked}
          readOnly
        />
      </td>
      <td className="store-cell-name" onClick={handleRedirectToStorePage}>
        {StorePresenter.name(store)}
        {isArchived && <div className="label-removed">Removed</div>}
      </td>
      <td className="center-align">
        {StorePresenter.defaultCashbackRate(store)}
      </td>
      <td className="center-align">
        {StorePresenter.birthdayCashbackRateReadable(store)}
      </td>
    </tr>
  );
};

export default StoreCell;

StoreCell.propTypes = {
  store: StorePresenter.shape().isRequired,
  isChecked: PropTypes.bool.isRequired,
  onStoreCheck: PropTypes.func.isRequired,
};
